import * as IkeModel from '@ikegps/core-shared';
import { MultiListInput } from '../../../components/input/multi.list.input';
import type { MithrilVNode } from '../../../mithril';
import { NestedListChooserState } from '../../multi.list.chooser/nested.list.chooser.state';
import { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const NestedListFieldView: CollectionFieldView<IkeModel.CollectionModelFieldNestedList> = {
	viewInline(field: IkeModel.CollectionModelFieldNestedList): string {
		return field.hasValue() ? field.displayValue : null;
	},

	viewDetail(field: IkeModel.CollectionModelFieldNestedList): MithrilVNode {
		return null;
	},

	viewEdit(field: IkeModel.CollectionModelFieldNestedList, ctrl: CollectionEditCtrl): MithrilVNode | string {
		let inputState = ctrl.changeState.getState(field.id) as NestedListChooserState;
		if (inputState == null) {
			inputState = new NestedListChooserState(field);
			inputState.onValue(() => setManualValue(field, inputState));
			ctrl.changeState.addState(field.id, inputState);
		}

		return MultiListInput.view(inputState);
	},
};

function setManualValue(field: IkeModel.CollectionModelFieldNestedList, inputState: NestedListChooserState) {
	const value = inputState.value;
	if (value != null) {
		field.Mutator.manual(Array.from(value));
	} else {
		field.Mutator.clear();
	}
}
